import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import AddIcon from "@mui/icons-material/Add";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";

// Same shape as the class picker's toolbar: one row on desktop; on a phone the
// count and "Clear" share the top line and the two real actions take the next
// one, half each.
const actionSx = { textTransform: "none", flex: { xs: "1 1 0", sm: "0 0 auto" }, minWidth: 0 };

function SlotsToolbar({ pickCount, sessionsN, countOk, repeatBusy, onAdd, onRepeatWeekly, onClear }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1, mb: 2 }}>
      <Chip label={`${pickCount} of ${sessionsN} selected`} color={countOk ? "primary" : "default"} sx={{ fontWeight: 700, order: 0 }} />

      {/* Undoing a selection is a way back, not a step forward — no outline
          competing with the actions, but red enough to find. */}
      {pickCount > 0 && (
        <Button
          size="small"
          variant="text"
          onClick={onClear}
          sx={{
            order: { xs: 1, sm: 5 },
            ml: "auto",
            textTransform: "none",
            color: "error.main",
            "&:hover": { color: "error.dark", bgcolor: "transparent" }
          }}
        >
          Clear
        </Button>
      )}

      {/* Line break on phones only, so the actions below start a row of their own. */}
      <Box sx={{ order: 2, flexBasis: "100%", height: 0, display: { xs: "block", sm: "none" } }} />

      <Button
        size="small"
        variant="outlined"
        startIcon={<AddIcon />}
        disabled={pickCount >= sessionsN}
        onClick={onAdd}
        sx={{ ...actionSx, order: 3 }}
      >
        Add session
      </Button>
      <Button
        size="small"
        variant="outlined"
        startIcon={repeatBusy ? <CircularProgress size="0.9rem" /> : <EventRepeatIcon />}
        disabled={pickCount === 0 || pickCount >= sessionsN || repeatBusy}
        onClick={onRepeatWeekly}
        sx={{ ...actionSx, order: 4 }}
      >
        Repeat weekly
      </Button>
    </Box>
  );
}

export default SlotsToolbar;
